import { useEffect, useState } from 'react';

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed'; platform: string }>;
}

const InstallPrompt = () => {
  const [installEvent, setInstallEvent] = useState<BeforeInstallPromptEvent | null>(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handleBeforeInstall = (event: Event) => {
      event.preventDefault();
      setInstallEvent(event as BeforeInstallPromptEvent);
    };
    const handleInstalled = () => setInstallEvent(null);

    window.addEventListener('beforeinstallprompt', handleBeforeInstall);
    window.addEventListener('appinstalled', handleInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstall);
      window.removeEventListener('appinstalled', handleInstalled);
    };
  }, []);

  const install = async () => {
    if (!installEvent) return;
    await installEvent.prompt();
    const choice = await installEvent.userChoice;
    if (choice.outcome === 'accepted') setInstallEvent(null);
  };

  if (!installEvent || dismissed) return null;

  return (
    <aside className="install-prompt" aria-label="Install Music Man">
      <div>
        <strong>Use it like an Android app</strong>
        <p>Install for a full-screen experience and quick home-screen access.</p>
      </div>
      <div className="install-actions">
        <button className="install-button" onClick={install}>Install</button>
        <button className="dismiss-button" onClick={() => setDismissed(true)} aria-label="Dismiss install suggestion">Not now</button>
      </div>
    </aside>
  );
};

export default InstallPrompt;
